import {
  AutoComplete,
  AutoCompleteAutomations,
  DateInput,
  FormInput,
  ISelectType,
  SwitchInput,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { GlobalAxios } from "../../../../../../../axios/axios-config";
import FormInformation from "../../../../../../../components/FormInformation/FormInformation";
import MainApi from "../../../../../../../services/mainApi.service";
import { BoardList } from "../BoardList/BoardList";
import { SelectTicketEvent } from "../SelectTicketEvent";
import { WhatsappTemplate } from "../WhatsappTemplate";
import { TMarComTicketAutomationRulesForm } from "../marComTicketAutomationRulesSchema";
import { ITicketAutomation } from "../../../../../../../models/ticket-automation-rules";

const TICKET_SERVICES_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketServices/";
const ticketServicesService = new MainApi<ISelectType>(TICKET_SERVICES_ROUTE);

const GENERIC_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApi<ISelectType>(GENERIC_ROUTE);

const translationPath = "page.4uMarCom.automationRules.ticketautomationRules.";

export const BasicData = memo(
  ({ ticketAutomation }: { ticketAutomation: ITicketAutomation | null }) => {
    const { t } = useTranslation();

    const { id } = useParams();

    const { control, setValue } =
      useFormContext<TMarComTicketAutomationRulesForm>();

    const currentAutomation = useWatch({ name: "ticketAutomation", control });

    const params = useMemo(() => {
      return { AutomationCodeList: ["15"], Enable: true };
    }, []);

    const actionAfter24HoursParams = useMemo(
      () => ({ Identifier: "TicketAutomationActionAfter24Hours" }),
      [],
    );

    const cleanTicketEvent = useCallback(() => {
      setValue("ticketEvent", null);
    }, [setValue]);

    const changeTicketServiceHandler = useCallback(() => {
      setValue("ticketAutomationTemplate", null);
    }, [setValue]);

    return (
      <>
        <Grid item xs={12} sm={12} textAlign={"end"}>
          <SwitchInput name="enable" label={t(translationPath + "enable")} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormInput
            name="name"
            label={t(translationPath + "name")}
            size="small"
            fullWidth
            autoFocus
          />
        </Grid>

        {ticketAutomation && (
          <Grid item xs={12} sm={6}>
            <FormInformation
              label={t(translationPath + "automation")}
              data={currentAutomation ? currentAutomation.name : "-"}
              minHeight={40}
            />
          </Grid>
        )}

        {!ticketAutomation && (
          <Grid item xs={12} sm={6}>
            <AutoCompleteAutomations
              name="ticketAutomation"
              params={params}
              axios={GlobalAxios}
              label={t(translationPath + "automation")}
              getOptionLabel={(option) => option.name}
              size="small"
              onValueChange={cleanTicketEvent}
              fullWidth
            />
          </Grid>
        )}
        <SelectTicketEvent />

        <Grid item xs={12} sm={6}>
          <AutoComplete
            name="ticketService"
            label={t(translationPath + "ticket_service")}
            getOptionLabel={(option) => option.name}
            size="small"
            fullWidth
            request={ticketServicesService.list}
            onValueChange={changeTicketServiceHandler}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DateInput
            name="initialDate"
            label={t(translationPath + "initial_date")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DateInput name="endDate" label={t(translationPath + "end_date")} />
        </Grid>

        <WhatsappTemplate />

        <Grid item xs={12} sm={6}>
          <AutoComplete
            name="actionAfter24Hours"
            label={t(translationPath + "action_after_24_hours")}
            getOptionLabel={(option) => option.name}
            size="small"
            fullWidth
            request={genericService.list}
            params={actionAfter24HoursParams}
          />
        </Grid>

        <BoardList
          label={t(translationPath + "robot") ?? undefined}
          boardFieldName="ticketChannelRobot"
          listFieldName="ticketChannelStepRobot"
        />

        <BoardList
          label={t(translationPath + "pendent") ?? undefined}
          boardFieldName="ticketChannelPendent"
          listFieldName="ticketChannelStepPendent"
        />

        <BoardList
          label={t(translationPath + "when_error") ?? undefined}
          boardFieldName="ticketChannelWhenError"
          listFieldName="ticketChannelStepWhenError"
        />

        <BoardList
          label={t(translationPath + "when_blacklist") ?? undefined}
          boardFieldName="ticketChannelWhenBlacklist"
          listFieldName="ticketChannelStepWhenBlacklist"
        />
      </>
    );
  },
);
